import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import {
  RegionActions,
  RegionIDsProp,
  setRegionsFilter,
} from '../state/region/region.actions';
import { RegionSearchService } from './region-search.service';
import { Region } from '@immosky/types';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RegionEffects {
  fetchRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionActions.SetBasedOnUrlValues),
      switchMap((action: RegionIDsProp) => {
        const ids = action.regionIDs;

        if (ids.length === 0) {
          return of(
            setRegionsFilter({
              regions: [],
            })
          );
        } else {
          return this.regionSearchService.searchByID(ids).pipe(
            map((regions: Region[]) => {
              return setRegionsFilter({
                regions,
              });
            })
          );
        }
      })
    )
  );

  constructor(
    private actions$: Actions,
    private regionSearchService: RegionSearchService
  ) {}
}
